const Vr1 = () => {

    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-9/PNG%20n.2/3d%20%209-2/publish%209-2/`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 9 Level 2 Tour"
        ></iframe>
      </div>
    );
};

export default Vr1;
